import React from "react";
import { Outlet } from "react-router-dom";

import BusinessAnalystManagerdMenu from "../layouts/BusinessAnalystManagerdMenu";
import Header from "../layouts/Header";

const BusinessAnalystLayout = () => {
    return (
        <>
            <div className="wrapper">
                <Header />
                <BusinessAnalystManagerdMenu />

                <Outlet />

                {/* <Footer /> */}
                <div id="sidebar-overlay"></div>
            </div>
        </>
    );
};

export default BusinessAnalystLayout;
